import { PRIZE_TIERS } from 'constants/LottoPrizeValues';
import { MAIN_PRIZE_CATEGORIES_2026 } from 'constants/PrizeCategories';
import { ReactElement } from 'react';

export interface PrizeGroupingInfo {
  code: string;
  title: string;
  subtitle: string | undefined;
  description: string;
  imageElement: ReactElement;
}

export function getPrizeGroupingInfo(
  groupingName: 'tier' | 'category',
): PrizeGroupingInfo[] {
  if (groupingName == 'tier') {
    return Object.entries(PRIZE_TIERS).map(([key, entry]) => ({
      title: entry.title,
      subtitle: entry.subtitle || '',
      description: 'Prizes ' + entry.examplePrizes,
      code: entry.key,
      imageElement: <img src={entry.badge} alt="" />,
    }));
  }

  return Object.values(MAIN_PRIZE_CATEGORIES_2026).map((entry) => ({
    title: entry.name,
    subtitle: '',
    description: entry.description,
    code: entry.categoryCode,
    imageElement: entry.svg,
  }));
}
